import { createContext, useContext } from 'react';
export const I18nContext = createContext(null);
export const getI18nContext = () => {
    var _a, _b;
    var _c;
    (_a = globalThis['@ui5/webcomponents-react']) !== null && _a !== void 0 ? _a : (globalThis['@ui5/webcomponents-react'] = {});
    (_b = (_c = globalThis['@ui5/webcomponents-react']).I18nContext) !== null && _b !== void 0 ? _b : (_c.I18nContext = I18nContext);
    return globalThis['@ui5/webcomponents-react'].I18nContext;
};
export const useI18nContext = () => useContext(getI18nContext());
